import {
  Flex,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@aws-amplify/ui-react"
import { I18n } from "aws-amplify/utils"
import { useState } from "react"
import { FaFileExcel, FaXmark } from "react-icons/fa6"
import { ButtonWithIcon } from "../../../components/ButtonWithIcon"
import SortOrderToggle, {
  type SortOrder,
} from "../../../components/SortOrderToggle"
import { runVerbrauchExport } from "../../../features/export"
import { UNIT_OF_MASS } from "../../../org-settings"
import {
  FeedingStatsPage,
  type FeedingStatsRenderComponentProps,
} from "../-components/FeedingStatsPage"

export default function VerbrauchOverall() {
  const title = "Verbrauch"

  return (
    <FeedingStatsPage
      title={title}
      isDataPresent={(feedingStats: any): boolean =>
        feedingStats && feedingStats.meta
      }
      RenderComponent={VerbrauchRenderComponent}
    />
  )
}

function VerbrauchRenderComponent({
  feedingStats,
}: FeedingStatsRenderComponentProps) {
  const [state, setState] = useState<"idle" | "done" | "error">("idle")
  const [sortOrder, setSortOrder] = useState<SortOrder>("alphabetical")

  const sortedTotalCons = [...feedingStats.total_cons].sort((a: any, b: any) =>
    sortOrder === "alphabetical"
      ? String(a.Komponentenname).localeCompare(String(b.Komponentenname), "de")
      : b.Abladung - a.Abladung
  )

  const handleExport = async () => {
    try {
      await runVerbrauchExport(feedingStats)
      setState("done")
    } catch (e) {
      console.error(e)
      setState("error")
    }
  }

  return (
    <div className="rm-list-container">
      <Flex
        className="mb-2 !flex-col !items-start gap-2 md:!flex-row md:!gap-0"
        justifyContent={"space-between"}
        alignItems="flex-start"
      >
        <div>
          Von{" "}
          <u>
            {new Date(feedingStats.meta.begin).toLocaleString("de-de", {
              dateStyle: "short",
              timeStyle: "short",
            })}
          </u>{" "}
          bis{" "}
          <u>
            {new Date(feedingStats.meta.end).toLocaleString("de-de", {
              dateStyle: "short",
              timeStyle: "short",
            })}
          </u>
        </div>
        <Flex className="!flex-wrap !justify-end gap-2 !self-end md:!self-auto">
          <SortOrderToggle
            value={sortOrder}
            onChange={setSortOrder}
            magnitudeLabel="Nach Verbrauch"
          />
          <ButtonWithIcon
            title={I18n.get("Export")}
            icon={<FaFileExcel />}
            onClick={handleExport}
          />
        </Flex>
      </Flex>

      {state === "done" && (
        <div className="export-banner export-banner-success">
          <span>
            ✓{" "}
            {I18n.get(
              "Datei gespeichert. Schauen Sie in Ihren Downloads-Ordner."
            )}
          </span>
          <button
            onClick={() => setState("idle")}
            className="export-banner-close"
            aria-label={I18n.get("Schließen")}
          >
            <FaXmark className="inline" />
          </button>
        </div>
      )}
      {state === "error" && (
        <div className="export-banner export-banner-error">
          <span>
            ✗ {I18n.get("Export fehlgeschlagen. Versuchen Sie es noch einmal.")}
          </span>
          <button
            onClick={() => setState("idle")}
            className="export-banner-close"
            aria-label={I18n.get("Schließen")}
          >
            <FaXmark className="inline" />
          </button>
        </div>
      )}

      <div className="overflow-x-auto">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell as="th">Futtermittel</TableCell>
              {/* <TableCell as="th">Frischmasse</TableCell> */}
              <TableCell as="th">{/* TS- */}Gewicht</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedTotalCons.map((e: any) => {
              // console.log("e = ", e)
              return (
                <TableRow key={e["Komponenten-ID"]}>
                  <TableCell>{e.Komponentenname}</TableCell>
                  {/* <TableCell>{e.Komponentenname}</TableCell> */}
                  <TableCell>
                    {e.Abladung.toLocaleString(undefined, {
                      maximumFractionDigits: 0,
                    })}{" "}
                    {UNIT_OF_MASS}
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}
